import DOMPurify from 'dompurify';
import { NgModule } from '@angular/core';
import { DOMPurifyInjectionToken } from './DOMPurifyInjectionToken';
import { SanitizerService } from './sanitizer.service';

@NgModule({
    providers: [{ provide: DOMPurifyInjectionToken, useValue: DOMPurify }, SanitizerService],
})
export class SanitizerModule {}
